module.exports = __webpack_public_path__ + "img/61_M3_climate_doesnt_love_me.20131274.jpg";